module.exports = __webpack_public_path__ + "img/aceB1.2aba2183.jpg";